// extracted by mini-css-extract-plugin
export default {"progress":"CreateDocumentProgress_progress__UK-Cl","hide":"CreateDocumentProgress_hide__zgmfG","waitingIcon":"CreateDocumentProgress_waitingIcon__yKpGh"};